import { configureSlices } from "utils/store/configureSlices";

import insightsV2UiSlice from "./insightsV2UiSlice";

export const { useSlices: useInsightsV2Store, useSliceSelector: useInsightsV2SliceSelector } = configureSlices({
  insightsV2UiSlice,
});
